/* eslint-disable */

import { HiX } from "react-icons/hi";
import Links from "./components/Links";
import routes from "routes.js";
import useAuth from "Hooks/useAuth";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import mitaxi_logo from '../../assets/img/logo_mitaxi.png'




const Sidebar = ({ open, onClose }) => {
  const screenWidth = window.innerWidth;
  let urlCallback;
  const useQuery = () => {
    const { search } = useLocation();

    return React.useMemo(() => new URLSearchParams(search), [search]);
  }
  urlCallback = useQuery().get('callback');
  if (!urlCallback) {
    urlCallback = localStorage.getItem('callback')
  }
  const { logout, authData } = useAuth()
  const { token } = authData()

  const navigate = useNavigate()
  return (
    <div
      className={`sm:none duration-175 linear fixed !z-50 flex min-h-full flex-col bg-white pb-10 shadow-2xl shadow-white/5 transition-all dark:!bg-navy-800 dark:text-white md:!z-50 lg:!z-50 xl:!z-50 ${open || screenWidth >= 1200 ? "translate-x-0" : "-translate-x-96"
        }`}
    >
      <span
        className="absolute top-4 right-4 block cursor-pointer xl:hidden"
        onClick={onClose}
      >
        <HiX />
      </span>


      <div className="mt-[58px] mb-7 h-px bg-gray-300 dark:bg-white/30" />
      {/* Nav item */}

      <ul className="mb-auto pt-1">
        <li><img style={{
          maxWidth:'80%'
        }} src={mitaxi_logo} /></li>
        <Links routes={routes.filter(d => d.show)} />
        <div className="relative mb-3 flex hover:cursor-pointer">
          {urlCallback ? <li onClick={() => {
            window.location.href = `${urlCallback}?token=${token}`;
          }}
            className="my-[3px] flex cursor-pointer items-center px-8"
            key={9999}
          >
            <span
              className="mt-3 text-sm font-medium hover:text-blue-500"
            >
              {"Comprar boletos"}
            </span>

          </li> : null}
          <li onClick={() => {
            logout()
            navigate('/')
          }}
            className="my-[3px] flex cursor-pointer items-center px-8"
            key={9999}
          >
            <span
              className="mt-3 text-sm font-medium text-red-500 hover:text-red-500"
            >
              {"Cerrar sesión"}
            </span>

          </li>
        </div>
      </ul>

      {/* Free Horizon Card */}
      {/* <div className="flex justify-center">
        <SidebarCard />
      </div> */}

      {/* Nav item end */}
    </div>
  );
};

export default Sidebar;
